import * as types from 'constants/ActionTypes';
import { ERROR, SUCCESS } from 'constants/AppConstants';
import i18n from 'i18n';

const orderPreferencesAlert = {
  open: false,
  severity: '',
  title: '',
  message: '',
};

const initState = {
  inputFieldValues: {},
  orderPreferencesAlert,
  saveLoading: false,
};

const { t } = i18n;

export default (state = initState, action = {}) => {
  switch (action.type) {
    case types.INIT_COVER_PAGE_FIELDS: {
      const { preferences } = action;
      const coverPageFields = {};
      Object.keys(preferences).forEach((key) => {
        if (key.includes('reportOptionsCover')) {
          coverPageFields[key] = preferences[key];
        }
      });
      return {
        ...state,
        inputFieldValues: {
          ...coverPageFields,
          ...state.inputFieldValues,
        },
      };
    }
    case types.SAVE_ORDER_PREFERENCES_LOADING: return { ...state, saveLoading: true, orderPreferencesAlert };
    case types.SAVE_ORDER_PREFERENCES_SUCCESS: return {
      ...state,
      orderPreferencesAlert: { open: true, severity: SUCCESS, message: t('order_preferences__save_success_message') },
      inputFieldValues: {},
      saveLoading: false,
    };
    case types.SAVE_ORDER_PREFERENCES_ERROR: return {
      ...state,
      saveLoading: false,
      orderPreferencesAlert: {
        open: true,
        severity: ERROR,
        message: action.errors || t('order_preferences__save_error_message'),
      },
    };
    case types.CLOSE_ORDER_PREFERENCES_ALERT: return { ...state, orderPreferencesAlert };
    case types.CANCEL_ORDER_PREFERENCES_CHANGES: return { ...state, inputFieldValues: {}, orderPreferencesAlert };
    case types.UPDATE_ORDER_PREFERENCES_INPUT_FIELD_PROPERTY: return {
      ...state,
      inputFieldValues: {
        ...state.inputFieldValues,
        [action.propertyName]: action.propertyValues,
      },
    };
    default: return state;
  }
};
